<template>
  <div class="ui container">
    <h2 class="ui centered header">
      <img src="/images/icons/360_feedback.png" />
      <div class="content">
        {{ $t("feedback 360") }}
        <div class="sub header">{{ $t("module command center") }}</div>
      </div>
    </h2>
    <div class="ui two link cards">
      <div
        class="card"
        style="margin: 10px 10px !important"
        @click="go_tree_management"
      >
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom:0">
            <img src="/images/icons/tree_management.png" class="ui image" />
            <div class="content" style="margin-top:8px">
              {{ $t("organigram management") }}
            </div>
          </h3>
        </div>
      </div>
      <div
        class="card"
        style="margin: 10px 10px !important"
        @click="go_survey_management"
      >
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom:0">
            <img src="/images/icons/feedback_survey.png" class="ui image" />
            <div class="content" style="margin-top:8px">
              {{ $t("deployed survey management") }}
            </div>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/filters";

export default {
  name: "Feedback360Index",
  components: {},
  filters: filters,
  data() {
    return {
      show_composer: false,
    };
  },
  computed: {},
  methods: {
    load(chart) {
      this.$refs.composer.load(chart);
      this.show_composer = true;
    },
    updated(/* chart */) {
      this.$refs.list.init();
    },
    deleted(uuid) {
      this.$refs.list.delete(uuid);
      this.show_composer = false;
    },
    add() {
      this.show_composer = true;
      this.$refs.composer.create();
    },
    go_tree_management() {
      let vm = this;
      vm.$router.push({ name: "Feedback360ThreeManagement" });
    },
    go_survey_management() {
      let vm = this;
      vm.$router.push({ name: "Feedback360SurveyManagement" });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style></style>
